import { render, staticRenderFns } from "./AccessLayout.vue?vue&type=template&id=8f98eebc&scoped=true"
import script from "./AccessLayout.vue?vue&type=script&lang=js"
export * from "./AccessLayout.vue?vue&type=script&lang=js"
import style0 from "./AccessLayout.vue?vue&type=style&index=0&id=8f98eebc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f98eebc",
  null
  
)

export default component.exports